<template>
  <div>
    <el-input
      v-model="searchText"
      placeholder="搜索"
      @keyup.enter.native="goToSearch"
    >
      <i slot="prefix" class="el-input__icon el-icon-search"></i>
    </el-input>
    <el-button
      id="searchButton"
      icon="el-icon-search"
      @click="goToSearch"
      type="success"
      circle
    >
    </el-button>
  </div>
</template>

<script>
export default {
  data() {
    return {
      searchText: ""
    };
  },
  methods: {
    goToSearch: function() {
      if (this.searchText.trim() !== "") {
        this.$router.push("/search/" + this.searchText);
        this.searchText = "";
      }
    }
  }
};
</script>
